import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=5024a0e9&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=5024a0e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024a0e9",
  null
  
)

export default component.exports